document.addEventListener('click', (event) => {
    if ( event.target.closest('.date_von.rangepicker')) {
        const range_div = event.target.closest('.range_div');
        const target_field_click = range_div.querySelector('.date_von.rangepicker');
        const target_field_beside = range_div.querySelector('.date_bis.rangepicker');
        rangepicking(target_field_click,target_field_beside);
    }

    if ( event.target.closest('.date_bis.rangepicker')) {
        const range_div = event.target.closest('.range_div');
        const target_field_click = range_div.querySelector('.date_bis.rangepicker');
        const target_field_beside = range_div.querySelector('.date_von.rangepicker');
        rangepicking(target_field_click,target_field_beside);
    }

})

window.rangepicking = (target_field_click,target_field_beside) => {
    moment.locale('de')

    //Dropdown
    const dropdown = target_field_click.nextElementSibling;

    // HTML-Elemente erstellen
    const date_picker_element = document.createElement('div');
    date_picker_element.classList.add('date_picker');
    const dates_element = document.createElement('div');
    dates_element.classList.add('dates');
    const month_element = document.createElement('div');
    month_element.classList.add('month');
    const prev_mth_element = document.createElement('div');
    prev_mth_element.classList.add('prev_mth','arrows');
    prev_mth_element.innerHTML = svgPfeilLinks;
    const next_mth_element = document.createElement('div');
    next_mth_element.classList.add('next_mth','arrows');
    next_mth_element.innerHTML = svgPfeilRechts;
    const mth_element = document.createElement('div');
    mth_element.classList.add('mth');
    const weekdays_element = document.createElement('div');
    weekdays_element.classList.add('weekdays');
    const calendarweek_element = document.createElement('div');
    calendarweek_element.classList.add('calendarweek');
    const days_element = document.createElement('div');
    days_element.classList.add('days');

    // Node-Tree
    dropdown.innerHTML = ''
    dropdown.append(date_picker_element);
    date_picker_element.append(dates_element);
    dates_element.append(month_element,weekdays_element,calendarweek_element,days_element);
    month_element.append(prev_mth_element,mth_element,next_mth_element);

    // Sonstige
    const weekdays = ['Mo','Di','Mi','Do','Fr','Sa','So'];
    let date = moment();
    if (target_field_click.value != '') {
        date = moment(target_field_click.value,'DD.MM.YYYY');
    }
    let selectedDate = date;
    if (target_field_beside.value != '') {
        besideDate = moment(target_field_beside.value,'DD.MM.YYYY');
    }

    // Alle Elemente mit Inhalt befuellen
    setMonth();
    populateWeekdays();
    populateDates();

    // Event-Listener fuer die Pfeile
    next_mth_element.addEventListener('click',goToNextMonth);
    prev_mth_element.addEventListener('click',goToPrevMonth);

    // ############################################################################
    // Auswahl des Monats
    // ############################################################################
    function setMonth() {
        if (target_field_click.value == '' && target_field_beside.value != '') {
            mth_element.textContent = besideDate.format('MMMM YYYY')
        }
        else {
            mth_element.textContent = date.format('MMMM YYYY')
        }
    }

    // ############################################################################
    // Befuellen der einzelnen Tage
    // ############################################################################
    function populateDates() {
        days_element.innerHTML = '';
        calendarweek_element.innerHTML = '';

        // Durchlaufvariable Tag -> Start = Monatsanfang + Wochenanfang
        let day_i = moment(mth_element.textContent,'MMMM YYYY');
        day_i.startOf('month').startOf('week').startOf('day');

        for (let i=0; i<42; i++) {

            // Kalenderwoche
            if ((i+7)%7==0) {
                const kw = document.createElement('div');
                kw.classList.add('kw');
                kw.textContent = day_i.isoWeek();
                calendarweek_element.append(kw);
            }

            const day_element = document.createElement('div');
            day_element.classList.add('day','uk-dropdown-close');
            day_element.textContent = day_i.format('DD');
            day_element.dataset.date = day_i.format('DD.MM.YYYY');

            // Tage, die zu einem anderen Monat gehören, heller färben
            if (day_i.format('MMMM') != moment(mth_element.textContent,'MMMM YYYY').format('MMMM')) {
                day_element.classList.add('othermonth');
            }

            // Click-Tag einfaerben
            if (target_field_click.value != '') {
                if (selectedDate.format('DD.MM.YYYY') == day_i.format('DD.MM.YYYY')) {
                    day_element.classList.add('selected');
                }
            }

            // Nachbar-Tag einfaerben
            if (target_field_beside.value != '') {
                if (besideDate.format('DD.MM.YYYY') == day_i.format('DD.MM.YYYY')) {
                    day_element.classList.add('selected');
                }
            }

            // In-Range-Tage einfaerben
            if (target_field_click.value != '' && target_field_beside.value != '') {
                if ((selectedDate < day_i && day_i < besideDate) || (selectedDate > day_i && day_i > besideDate)){
                    day_element.classList.add('inrange');
                }
            }

            // Event-Listener
            day_element.addEventListener('click',updateSelectedDate)
            day_element.addEventListener('mouseenter',colorrange)

            // Element hinzufuegen und Tag erhoehen
            days_element.appendChild(day_element);
            day_i = day_i.add('1','d');

        }
    }
    // ############################################################################
    // Funktionen durch Klicken auf die Pfeile
    // ############################################################################
    function goToNextMonth() {
        const element   = moment(mth_element.textContent,'MMMM YYYY');
        const nextMonth = element.add(1,'M');
        mth_element.textContent = nextMonth.format('MMMM YYYY');
        populateDates()
    }

    function goToPrevMonth() {
        const element   = moment(mth_element.textContent,'MMMM YYYY');
        const prevMonth = element.subtract(1,'M');
        mth_element.textContent = prevMonth.format('MMMM YYYY');
        populateDates()
    }

    // ############################################################################
    // Befuellen der Wochentage
    // ############################################################################
    function populateWeekdays() {
        weekdays.forEach(wd => {
            const weekday_element = document.createElement('div');
            weekday_element.classList.add('weekday');
            weekday_element.textContent = wd;
            weekdays_element.appendChild(weekday_element);
        });
    }

    // ############################################################################
    // Funktion durch Klicken auf einen Tag
    // ############################################################################
    function updateSelectedDate() {
        // Alle Tage entfaerben
        const days = days_element.querySelectorAll('.day');
        days.forEach(d => {
            d.classList.remove('selected')
        });

        // Ausgewählten Tag einfaerben
        //this.classList.add('selected');

        // Selected Date aendern
        selectedDate = moment(this.dataset.date,'DD.MM.YYYY');

        // Selected Date anzeigen und Filter auslösen
        target_field_click.value = selectedDate.format('DD.MM.YYYY');
        target_field_click.dispatchEvent(new Event('change',{bubbles:true}));

        if (target_field_beside.value == '') {
            target_field_beside.click()
            target_field_beside.focus()
        }
    }

    // ############################################################################
    // Range zwischen den ausgewählten Tagen einfaerben
    // ############################################################################
    function colorrange() {
        if (target_field_click.value == '' && target_field_beside.value != '') {

            const days = days_element.querySelectorAll('.day');
            const mouseday = moment(this.dataset.date,'DD.MM.YYYY');

            days.forEach(d => {
                d.classList.remove('inrange')
                const moment_d = moment(d.dataset.date,'DD.MM.YYYY')
                if ((moment_d > besideDate && moment_d < mouseday) || (moment_d < besideDate && moment_d > mouseday)) {
                    d.classList.add('inrange')
                }

            });

        }


    }
}
